import { IconProps } from '../icon';

export function AccountIcon(props: IconProps) {
  return (
    <svg
      width="32"
      height="33"
      viewBox="0 0 32 33"
      {...props}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5 1C7.944 1 1 7.944 1 16.5C1 25.056 7.944 32 16.5 32C25.056 32 32 25.056 32 16.5C32 7.944 25.056 1 16.5 1ZM16.5 7.2C19.4915 7.2 21.925 9.6335 21.925 12.625C21.925 15.6165 19.4915 18.05 16.5 18.05C13.5085 18.05 11.075 15.6165 11.075 12.625C11.075 9.6335 13.5085 7.2 16.5 7.2ZM16.5 28.9C13.3535 28.9 9.6335 27.629 6.983 24.436C9.69799 22.3059 13.0491 21.1481 16.5 21.1481C19.9509 21.1481 23.302 22.3059 26.017 24.436C23.3665 27.629 19.6465 28.9 16.5 28.9Z"
        fill="#83B735"
      />
    </svg>
  );
}

export default AccountIcon;
